/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const IdeaIcon = ({ width, height }) => {
  return (
    <svg
      id="ey4m1xtluoba1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 192.050000 154.330000"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            '#ey4m1xtluoba3_to {animation: ey4m1xtluoba3_to__to 3000ms linear infinite normal forwards}@keyframes ey4m1xtluoba3_to__to { 0% {transform: translate(125.145000px,53.100862px)} 100% {transform: translate(125.145000px,20.623436px)} }#ey4m1xtluoba4_to {animation: ey4m1xtluoba4_to__to 3000ms linear infinite normal forwards}@keyframes ey4m1xtluoba4_to__to { 0% {transform: translate(105.247864px,52.816132px)} 100% {transform: translate(105.970000px,26.976097px)} }#ey4m1xtluoba5_to {animation: ey4m1xtluoba5_to__to 3000ms linear infinite normal forwards}@keyframes ey4m1xtluoba5_to__to { 0% {transform: translate(90.439576px,86.425000px)} 100% {transform: translate(90.439576px,63.280000px)} }',
        }}
      />
      <defs>
        <linearGradient
          id="ey4m1xtluoba3-fill"
          x1="68.940000"
          y1="61.820000"
          x2="175.790000"
          y2="51.550000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            id="ey4m1xtluoba3-fill-0"
            offset="13%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba3-fill-1"
            offset="55%"
            stopColor="rgba(95,121,62,0.7551999974250794)"
          />
          <stop
            id="ey4m1xtluoba3-fill-2"
            offset="64%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba3-fill-3"
            offset="73%"
            stopColor="rgb(149,189,97)"
          />
          <stop
            id="ey4m1xtluoba3-fill-4"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba5-fill"
          x1={0}
          y1="0.500000"
          x2={1}
          y2="0.500000"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
        >
          <stop
            id="ey4m1xtluoba5-fill-0"
            offset="0%"
            stopColor="rgba(34,49,43,0.84)"
          />
          <stop
            id="ey4m1xtluoba5-fill-1"
            offset="100%"
            stopColor="rgba(221,206,212,0.74)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba7-fill"
          x1="125.450000"
          y1="117.390000"
          x2="133.940000"
          y2="106.340000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop id="ey4m1xtluoba7-fill-0" offset="1%" stopColor="rgb(0,0,0)" />
          <stop
            id="ey4m1xtluoba7-fill-1"
            offset="8%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba7-fill-2"
            offset="21%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba7-fill-3"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba8-fill"
          x1="136.030000"
          y1="70.410000"
          x2="115.610000"
          y2="204.530000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop id="ey4m1xtluoba8-fill-0" offset="1%" stopColor="rgb(0,0,0)" />
          <stop
            id="ey4m1xtluoba8-fill-1"
            offset="8%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba8-fill-2"
            offset="21%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba8-fill-3"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba9-fill"
          x1="120.250000"
          y1="86.570000"
          x2="118.560000"
          y2="115.710000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop id="ey4m1xtluoba9-fill-0" offset="1%" stopColor="rgb(0,0,0)" />
          <stop
            id="ey4m1xtluoba9-fill-1"
            offset="8%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba9-fill-2"
            offset="21%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba9-fill-3"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba11-fill"
          x1="151.570000"
          y1="102.320000"
          x2="95.160000"
          y2="65.360000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop id="ey4m1xtluoba11-fill-0" offset="1%" stopColor="rgb(0,0,0)" />
          <stop
            id="ey4m1xtluoba11-fill-1"
            offset="13%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba11-fill-2"
            offset="25%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba11-fill-3"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba15-fill"
          x1="6.600002"
          y1="-3.890000"
          x2="6.570002"
          y2="6.450000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop id="ey4m1xtluoba15-fill-0" offset="1%" stopColor="rgb(0,0,0)" />
          <stop
            id="ey4m1xtluoba15-fill-1"
            offset="13%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba15-fill-2"
            offset="25%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba15-fill-3"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba16-fill"
          x1="6.190003"
          y1="-3.670003"
          x2="5.540003"
          y2="6.849997"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop id="ey4m1xtluoba16-fill-0" offset="1%" stopColor="rgb(0,0,0)" />
          <stop
            id="ey4m1xtluoba16-fill-1"
            offset="13%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba16-fill-2"
            offset="25%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba16-fill-3"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba17-fill"
          x1="5.269997"
          y1="-2.820003"
          x2="4.909997"
          y2="5.609997"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop id="ey4m1xtluoba17-fill-0" offset="1%" stopColor="rgb(0,0,0)" />
          <stop
            id="ey4m1xtluoba17-fill-1"
            offset="13%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba17-fill-2"
            offset="25%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba17-fill-3"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba20-fill"
          x1="119.330000"
          y1="120.800000"
          x2="92.440000"
          y2="116.020000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop id="ey4m1xtluoba20-fill-0" offset="1%" stopColor="rgb(0,0,0)" />
          <stop
            id="ey4m1xtluoba20-fill-1"
            offset="8%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba20-fill-2"
            offset="21%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba20-fill-3"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba24-fill"
          x1="118.230000"
          y1="139.250000"
          x2="118.910000"
          y2="138.080000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop id="ey4m1xtluoba24-fill-0" offset="1%" stopColor="rgb(0,0,0)" />
          <stop
            id="ey4m1xtluoba24-fill-1"
            offset="8%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba24-fill-2"
            offset="21%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba24-fill-3"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba25-fill"
          x1="140.610000"
          y1="160.750000"
          x2="161.440000"
          y2="124.700000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop id="ey4m1xtluoba25-fill-0" offset="1%" stopColor="rgb(0,0,0)" />
          <stop
            id="ey4m1xtluoba25-fill-1"
            offset="8%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba25-fill-2"
            offset="21%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba25-fill-3"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
        <linearGradient
          id="ey4m1xtluoba31-fill"
          x1="96.770000"
          y1="79.520000"
          x2="79.100000"
          y2="30.370000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop id="ey4m1xtluoba31-fill-0" offset="1%" stopColor="rgb(0,0,0)" />
          <stop
            id="ey4m1xtluoba31-fill-1"
            offset="13%"
            stopColor="rgba(0,0,0,0.6899999976158142)"
          />
          <stop
            id="ey4m1xtluoba31-fill-2"
            offset="25%"
            stopColor="rgba(0,0,0,0.3199999928474426)"
          />
          <stop
            id="ey4m1xtluoba31-fill-3"
            offset="100%"
            stopColor="rgba(0,0,0,0)"
          />
        </linearGradient>
      </defs>
      <path
        id="ey4m1xtluoba2"
        style={{ isolation: 'isolate' }}
        d="M195.330000,113.160000C192.301788,118.330335,190.162113,123.971911,189,129.850000C187.479928,138.526339,182.749625,146.312596,175.750000,151.660000C172.192438,154.296587,168.221773,156.324160,164,157.660000C161.282172,158.539444,158.500601,159.208091,155.680000,159.660000L155.530000,159.660000C142.930000,161.660000,127.240000,160.920000,115.040000,157.270000C107.840000,155.110000,102.100000,151.970000,94.340000,151.270000C82.600000,150.160000,71.200000,151.430000,59.520000,148.770000C-3.260000,134.370000,7.330000,75.370000,39.380000,56.160000C51.440000,48.930000,66.120000,46.430000,77,38.050000C81,34.970000,83.420000,29.690000,86.710000,25.900000C93.120000,18.530000,101.710000,12.190000,110.920000,8.900000C136.550000,-0.150000,162.800000,16.190000,182,31.840000C218.560000,61.680000,204.600000,97.240000,195.330000,113.160000Z"
        transform="matrix(1 0 0 1 -12.96523475073487 -6.32000017166138)"
        opacity="0.18000000715255737"
        fill="rgb(149,189,81)"
        stroke="none"
        strokeWidth={1}
      />
      <g id="ey4m1xtluoba3_to" transform="translate(125.145000,53.100862)">
        <polygon
          id="ey4m1xtluoba3"
          points="104.690000,88.860000 104.690000,26.580000 98.300000,26.580000 111.870000,10.790000 127.330000,26.750000 120.410000,26.750000 120.410000,103.770000 104.690000,88.860000"
          transform="translate(-112.815000,-36.047612)"
          fill="url(#ey4m1xtluoba3-fill)"
          stroke="none"
          strokeWidth={1}
        />
      </g>
      <g id="ey4m1xtluoba4_to" transform="translate(105.247864,52.816132)">
        <polygon
          id="ey4m1xtluoba4"
          points="92.980000,90.220000 92.980000,45.600000 86.580000,45.600000 100.160000,29.820000 115.610000,45.770000 108.690000,45.770000 108.690000,90.620000 92.980000,90.220000"
          transform="translate(-99.982104,-40.669673)"
          fill="rgb(149,189,81)"
          stroke="none"
          strokeWidth={1}
        />
      </g>
      <g id="ey4m1xtluoba5_to" transform="translate(90.439576,86.425000)">
        <polygon
          id="ey4m1xtluoba5"
          points="87.810000,112.890000 87.810000,62.480000 83.100000,62.480000 93.100000,50.860000 104.470000,62.600000 99.380000,62.600000 99.380000,95.610000 87.810000,112.890000"
          transform="translate(-93.785000,-81.980000)"
          fill="url(#ey4m1xtluoba5-fill)"
          stroke="none"
          strokeWidth={1}
        />
      </g>
      <path
        id="ey4m1xtluoba6"
        d="M175.740000,151.660000C172.182438,154.296587,168.211773,156.324160,163.990000,157.660000C161.272172,158.539444,158.490601,159.208091,155.670000,159.660000C153.670000,157.910000,151.400000,155.660000,149.960000,154.550000C149.800000,154.430000,149.660000,154.320000,149.520000,154.230000C145.310000,151.380000,140.230000,149.530000,135.640000,147.360000C133.340000,146.270000,131.110000,145.060000,128.850000,143.890000C126.090145,142.380080,123.222310,141.076519,120.270000,139.990000L119.770000,139.820000L119.390000,139.690000C117.401641,139.173119,115.533348,138.272942,113.890000,137.040000C112.250000,135.610000,111.310000,133.570000,110.290000,131.660000C108.720000,128.720000,108.180000,124.870000,105.070000,123.660000C103.660000,123.120000,103.190000,121.390000,103.070000,119.910000C102.788392,115.588619,103.013253,111.249130,103.740000,106.980000Q104.570000,100.700000,105.430000,94.410000C105.466783,93.893042,105.609760,93.389220,105.850000,92.930000C106.591311,91.937508,107.958686,91.658013,109.030000,92.280000C110.042959,92.928120,110.761107,93.947890,111.030000,95.120000C112.110000,98.930000,110.400000,103.270000,112.030000,106.850000L112.030000,106.920000C112.518876,107.836594,113.109250,108.695320,113.790000,109.480000C115.790000,111.960000,117.790000,114.480000,119.980000,116.700000C121.112632,118.047111,122.572752,119.080214,124.220000,119.700000C125.911531,120.316711,127.806630,119.727307,128.850000,118.260000L128.990000,118.010000C129.476496,116.565359,129.319924,114.981431,128.560000,113.660000C127.362755,111.501947,125.948790,109.471466,124.340000,107.600000C123.432829,106.453838,122.651663,105.213360,122.010000,103.900000C121.037631,101.751029,120.621527,99.391962,120.800000,97.040000C120.781715,95.955261,121.134529,94.896820,121.800000,94.040000C122.560000,93.250000,124.110000,92.960000,124.700000,93.880000C128.230000,99.240000,129.020000,103.800000,134.820000,108.450000C136.390000,109.700000,140.910000,114.820000,142.600000,115.900000C147.770000,119.210000,150.600000,125.040000,154.170000,130.050000C157.740000,135.060000,161.940000,139.200000,166.170000,143.410000C168,144.840000,173.340000,148.780000,175.740000,151.660000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(255,187,171)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba7"
        d="M128.650000,113.500000C127.456431,111.333437,126.042260,109.295958,124.430000,107.420000C124.620000,106.600000,125.170000,106.420000,126.550000,107.800000C128.810000,109.970000,131.840000,115.580000,135.380000,115.960000C133.430000,115.750000,131.220000,115.610000,129.770000,116.960000C129.493337,117.217358,129.260304,117.517937,129.080000,117.850000C129.573129,116.406120,129.416280,114.819386,128.650000,113.500000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="url(#ey4m1xtluoba7-fill)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba8"
        d="M146.610000,130.890000C138.060000,133.030000,133.870000,141.800000,129.470000,134.160000C129.050000,135.890000,123.100000,124.710000,122.680000,126.440000C123.340000,123.820000,116.300000,128.710000,114.210000,127C112.120000,125.290000,115.090000,117.060000,112.650000,118.240000C110.561638,114.520827,109.934146,110.156904,110.890000,106L112.090000,106.900000C112.578741,107.819771,113.169098,108.681826,113.850000,109.470000C115.850000,111.940000,117.850000,114.410000,120.040000,116.680000C121.178920,118.020257,122.637122,119.052004,124.280000,119.680000C125.972158,120.265185,127.848233,119.681697,128.910000,118.240000C128.916863,118.220589,128.916863,118.199411,128.910000,118.180000C128.479459,119.187863,128.398495,120.310798,128.680000,121.370000C129.146927,122.870425,129.994435,124.224371,131.140000,125.300000C135.218491,129.355878,140.880941,131.401973,146.610000,130.890000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="url(#ey4m1xtluoba8-fill)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba9"
        d="M133.520000,117.760000C132.470689,119.999233,130.618268,121.762424,128.330000,122.700000C129.419001,124.517124,130.635380,126.254808,131.970000,127.900000C129.679558,126.559531,127.523010,125.002397,125.530000,123.250000C123.530000,121.440000,121.120000,119.250000,118.450000,119.840000C116.630000,120.230000,114.990000,121.900000,113.060000,120.350000C112.488606,119.871629,112.065406,119.240297,111.840000,118.530000C111.200000,116.530000,110.520000,114.590000,109.990000,112.530000C109.684175,111.643009,109.505730,110.717118,109.460000,109.780000C109.460000,109.290000,109.830000,107.930000,108.860000,108.400000C106.874366,109.368551,105.105472,110.729239,103.660000,112.400000C104.025282,111.295541,104.309372,110.165866,104.510000,109.020000C104.618881,107.880906,104.853646,106.757383,105.210000,105.670000L106.490000,101.970000C106.897351,100.932509,107.169583,99.846939,107.300000,98.740000C107.410000,97.160000,105.580000,93.200000,107.800000,92.350000C109.260000,91.780000,110.680000,93.890000,111.010000,95.030000C112.090000,98.830000,110.380000,103.170000,112.010000,106.750000C112.664948,107.942812,113.449711,109.059590,114.350000,110.080000C116.039106,112.265900,117.845071,114.358950,119.760000,116.350000C121.310000,117.960000,123.060000,119.610000,125.430000,119.770000C126.374172,119.856732,127.316460,119.585467,128.070000,119.010000C129.870000,117.590000,129.460000,115.270000,128.600000,113.470000C126.910000,109.920000,123.700000,107.270000,122.050000,103.700000C121.086972,101.548152,120.671289,99.191469,120.840000,96.840000C120.817643,95.754639,121.170898,94.694875,121.840000,93.840000C125.050000,90.480000,125.840000,97.680000,126.040000,99.320000C126.484126,101.947800,127.288362,104.501838,128.430000,106.910000C128.900000,108.030000,129.580000,109.320000,130.790000,109.480000L128.920000,110.250000C129.369070,113.274425,131.029824,115.985787,133.520000,117.760000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="url(#ey4m1xtluoba9-fill)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba10"
        style={{ isolation: 'isolate' }}
        d="M128.610000,77C128.395207,79.741781,127.231862,82.323062,125.320000,84.300000C123.607651,85.992148,122.387483,88.117937,121.790000,90.450000C121.630000,91.160000,121.540000,91.900000,121.410000,92.680000L110.900000,92.680000C110.820000,92.150000,110.770000,91.610000,110.670000,91.090000C110.220589,88.840660,109.150159,86.762155,107.580000,85.090000C106.184113,83.652667,105.086373,81.953379,104.350000,80.090000C103.086682,76.575253,103.445098,72.681453,105.328801,69.456383C107.212505,66.231312,110.427989,64.006273,114.110000,63.380000C114.440000,63.380000,114.780000,63.290000,115.110000,63.260000C118.817981,62.956906,122.469118,64.315903,125.076522,66.969662C127.683926,69.623420,128.978381,73.297935,128.610000,77Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(255,255,255)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba11"
        d="M126.550000,77C126.334667,79.739656,125.175406,82.319719,123.270000,84.300000C121.550734,85.986813,120.329387,88.114656,119.740000,90.450000C119.570000,91.160000,119.490000,91.900000,119.360000,92.680000L110.900000,92.680000C110.820000,92.150000,110.770000,91.610000,110.670000,91.090000C110.220589,88.840660,109.150159,86.762155,107.580000,85.090000C106.184113,83.652667,105.086373,81.953379,104.350000,80.090000C103.086682,76.575253,103.445098,72.681453,105.328801,69.456383C107.212505,66.231312,110.427989,64.006273,114.110000,63.380000C114.440000,63.380000,114.780000,63.290000,115.110000,63.260000C118.458856,63.540951,121.555129,65.153271,123.705437,67.735896C125.855744,70.318520,126.880421,73.655662,126.550000,77Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="url(#ey4m1xtluoba11-fill)"
        stroke="none"
        strokeWidth={1}
      />
      <rect
        id="ey4m1xtluoba12"
        width="13.160000"
        height="2.740000"
        rx="1.370000"
        ry="1.370000"
        transform="matrix(1 0 0 1 96.05999755859375 86.31999969482422)"
        fill="rgb(149,189,81)"
        stroke="none"
        strokeWidth={1}
      />
      <rect
        id="ey4m1xtluoba13"
        width="11.770000"
        height="2.450000"
        rx="1.220000"
        ry="1.220000"
        transform="matrix(1 0 0 1 96.51999664306641 88.62000274658203)"
        fill="rgb(149,189,81)"
        stroke="none"
        strokeWidth={1}
      />
      <rect
        id="ey4m1xtluoba14"
        width="10.210000"
        height="2.130000"
        rx="1.060000"
        ry="1.060000"
        transform="matrix(1 0 0 1 97.30000305175781 90.62000274658203)"
        fill="rgb(149,189,81)"
        stroke="none"
        strokeWidth={1}
      />
      <rect
        id="ey4m1xtluoba15"
        width="13.160000"
        height="2.740000"
        rx="1.370000"
        ry="1.370000"
        transform="matrix(1 0 0 1 96.05999755859375 86.31999969482422)"
        fill="url(#ey4m1xtluoba15-fill)"
        stroke="none"
        strokeWidth={1}
      />
      <rect
        id="ey4m1xtluoba16"
        width="11.770000"
        height="2.450000"
        rx="1.220000"
        ry="1.220000"
        transform="matrix(1 0 0 1 96.51999664306641 88.62000274658203)"
        fill="url(#ey4m1xtluoba16-fill)"
        stroke="none"
        strokeWidth={1}
      />
      <rect
        id="ey4m1xtluoba17"
        width="10.210000"
        height="2.130000"
        rx="1.060000"
        ry="1.060000"
        transform="matrix(1 0 0 1 97.30000305175781 90.62000274658203)"
        fill="url(#ey4m1xtluoba17-fill)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba18"
        d="M113.540000,92.600000C113.461993,90.679159,113.217747,88.768685,112.810000,86.890000C112.490048,85.330736,112.256360,83.755009,112.110000,82.170000C111.950000,79.780000,112.420000,78.100000,113.560000,77.050000C113.749797,76.813429,114.036703,76.675780,114.340000,76.675780C114.643297,76.675780,114.930203,76.813429,115.120000,77.050000L115.220000,76.930000C115.414036,76.685102,115.674370,76.501133,115.970000,76.400000C116.274069,76.319481,116.597650,76.362625,116.870000,76.520000C117.060756,76.637088,117.227130,76.789881,117.360000,76.970000C117.677128,76.766419,118.063717,76.701386,118.430000,76.790000C119.120000,76.960000,119.590000,77.600000,119.790000,78.650000C120.109592,81.158904,119.919116,83.706513,119.230000,86.140000C118.681313,88.199692,118.445343,90.330159,118.530000,92.460000L117.780000,92.530000C117.685325,90.323365,117.924695,88.115095,118.490000,85.980000C119.020000,83.500000,119.490000,81.150000,119.060000,78.800000C118.970000,78.370000,118.760000,77.640000,118.250000,77.520000C118.065759,77.476475,117.871703,77.516751,117.720000,77.630000C117.775355,77.759122,117.818867,77.893006,117.850000,78.030000C118.031281,78.779600,118.118619,79.548839,118.110000,80.320000C118.124638,80.562633,118.033455,80.799711,117.860000,80.970000C117.704367,81.107541,117.487877,81.153118,117.290000,81.090000C116.946881,80.938721,116.700101,80.628377,116.630000,80.260000C116.394619,79.561068,116.349747,78.812035,116.500000,78.090000C116.563122,77.870519,116.664697,77.663982,116.800000,77.480000C116.720869,77.355009,116.614991,77.249131,116.490000,77.170000C116.387737,77.126656,116.272263,77.126656,116.170000,77.170000C116.020673,77.237365,115.890182,77.340384,115.790000,77.470000C115.734486,77.532347,115.684309,77.599249,115.640000,77.670000C116.262251,78.512100,116.537842,79.560777,116.410000,80.600000C116.340000,81.110000,116.030000,81.600000,115.490000,81.600000C115.111147,81.551585,114.792957,81.291601,114.670000,80.930000C114.195184,79.919672,114.195184,78.750328,114.670000,77.740000L114.670000,77.740000C114.490000,77.570000,114.380000,77.530000,114.330000,77.540000C114.226307,77.571260,114.133008,77.630004,114.060000,77.710000C113.110000,78.590000,112.700000,80.110000,112.850000,82.230000C112.994483,83.784872,113.224835,85.330565,113.540000,86.860000C113.953599,88.785234,114.201175,90.742418,114.280000,92.710000ZM115.250000,78.350000C115.008480,79.063453,115.044177,79.841654,115.350000,80.530000C115.430000,80.710000,115.500000,80.760000,115.520000,80.760000C115.607195,80.663938,115.656892,80.539696,115.660000,80.410000C115.752083,79.696980,115.608075,78.973425,115.250000,78.350000ZM117.180000,78.430000C117.130957,78.973312,117.192182,79.520933,117.360000,80.040000L117.360000,80.040000C117.348521,79.499013,117.288277,78.960164,117.180000,78.430000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(149,189,81)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba19"
        d="M106.740000,105.630000C106.740000,105.630000,101.350000,117.300000,101.890000,119.220000C102.495712,120.839626,103.305583,122.375358,104.300000,123.790000L109.300000,129.500000C109.300000,129.500000,111.870000,136.350000,113.840000,136.950000C115.810000,137.550000,118.460000,138.150000,118.460000,138.150000C118.460000,138.150000,109.040000,124.740000,108.120000,123.210000C107.200000,121.680000,109.480000,113.070000,110.120000,111.840000C110.571302,111.112287,110.908542,110.319774,111.120000,109.490000C111.220000,108.980000,115.860000,104.810000,116.270000,102.770000C116.680000,100.730000,116.750000,98.770000,115.860000,98.190000C114.970000,97.610000,114,96.760000,114,96.760000L107.650000,103.650000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(255,187,171)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba20"
        d="M105.830000,117.080000C105.662484,117.983072,105.608732,118.903569,105.670000,119.820000C105.745366,120.667667,105.944131,121.499782,106.260000,122.290000C107.086873,124.062010,108.221056,125.673565,109.610000,127.050000Q111.470000,129.100000,113.370000,131.050000C114.480000,127.150000,113.110000,123.050000,112.070000,119.120000C111.030000,115.190000,110.760000,111.810000,112.180000,108.120000C110.780000,107.960000,108.880000,110.540000,108.180000,111.580000C106.998245,113.216238,106.195502,115.094999,105.830000,117.080000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="url(#ey4m1xtluoba20-fill)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba21"
        d="M117.900000,106.510000C117.900000,106.510000,110.560000,110.880000,110.180000,111.840000C109.800000,112.800000,107.300000,119.320000,107.610000,122.440000C107.920000,125.560000,119,138.560000,119,138.560000C119,138.560000,142.710000,151.960000,147.260000,151.320000C151.810000,150.680000,157.340000,142.970000,152.630000,138.150000C147.920000,133.330000,137.280000,131.300000,135.020000,131.090000C132.760000,130.880000,126.830000,128.430000,122.940000,126.180000C119.050000,123.930000,115.060000,121.370000,115.060000,121.370000C115.060000,121.370000,114.060000,116.370000,114.060000,115.940000C114.060000,115.510000,118.560000,112.870000,119.180000,110.720000C119.800000,108.570000,119.330000,107,117.900000,106.510000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(255,187,171)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba22"
        d="M111.860000,102.320000C112.169825,102.308707,112.473496,102.230230,112.750000,102.090000C113.252369,101.864154,113.731336,101.589502,114.180000,101.270000C114.507754,101.101836,114.753975,100.808767,114.863103,100.456925C114.972230,100.105083,114.935067,99.724119,114.760000,99.400000C114.508504,98.552274,114.173530,97.731589,113.760000,96.950000C113.840000,97.100000,112.690000,98.380000,112.550000,98.550000C112.110000,99.100000,111.640000,99.630000,111.160000,100.150000C110.680000,100.670000,110.360000,100.810000,110.560000,101.400000C110.768888,101.940195,111.281083,102.302672,111.860000,102.320000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        opacity="0.20999999344348907"
        fill="rgb(255,255,255)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba23"
        d="M114.710000,111C115.799440,111.275573,116.952159,110.929757,117.710000,110.100000C117.874827,109.963691,118.007924,109.793055,118.100000,109.600000C118.165759,109.433637,118.206208,109.258356,118.220000,109.080000C118.283378,108.390890,118.151700,107.697845,117.840000,107.080000C117.421024,107.168452,117.023500,107.338334,116.670000,107.580000L115.250000,108.400000C114.736747,108.612455,114.255484,108.895155,113.820000,109.240000C113.280000,109.900000,114.120000,110.830000,114.710000,111Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        opacity="0.20999999344348907"
        fill="rgb(255,255,255)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba24"
        d="M117.270000,137.770000C118.024113,138.530071,118.862930,139.201125,119.770000,139.770000L119.390000,139.640000C118.634062,139.074856,117.925082,138.449483,117.270000,137.770000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="url(#ey4m1xtluoba24-fill)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba25"
        d="M164,157.610000C161.282172,158.489444,158.500601,159.158091,155.680000,159.610000L155.530000,159.610000C153.590000,157.950000,151.450000,155.610000,149.970000,154.480000C149.810000,154.360000,149.670000,154.250000,149.530000,154.160000C145.320000,151.310000,140.240000,149.460000,135.650000,147.290000C133.350000,146.200000,131.120000,144.990000,128.860000,143.820000C134.080000,145.910000,139.310000,147.950000,144.650000,149.680000C146.430000,150.260000,148.500000,150.770000,150.070000,149.740000C150.945999,149.060721,151.634345,148.169313,152.070000,147.150000C153.170000,145.040000,154.150000,142.800000,155.400000,140.790000C155.910000,141.520000,155.140000,142.640000,154.940000,143.440000C154.636045,144.634723,154.544652,145.873607,154.670000,147.100000C154.986937,149.974652,156.450875,152.599645,158.730000,154.380000C160.330000,155.620000,162.330000,156.400000,164,157.610000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="url(#ey4m1xtluoba25-fill)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba26"
        d="M84.580000,105.210000C83.604785,104.990614,82.672324,104.612224,81.820000,104.090000L83.910000,100.690000C84.390651,100.979546,84.913641,101.192116,85.460000,101.320000ZM89.720000,104.890000L88.360000,101.140000C88.888293,100.948476,89.381529,100.671453,89.820000,100.320000L92.310000,103.430000C91.533578,104.056889,90.658304,104.550287,89.720000,104.890000ZM78.360000,100.270000C77.921210,99.370668,77.637228,98.403777,77.520000,97.410000L81.520000,96.920000C81.593717,97.478702,81.755737,98.022144,82,98.530000ZM95.270000,99.210000L91.500000,97.940000C91.675506,97.404008,91.766595,96.843984,91.770000,96.280000L95.770000,96.280000L95.770000,96.280000C95.765225,97.277485,95.596300,98.267383,95.270000,99.210000ZM81.940000,94.050000L78.350000,92.320000C78.782439,91.423930,79.356465,90.603410,80.050000,89.890000L82.900000,92.670000C82.511299,93.078190,82.187532,93.543605,81.940000,94.050000ZM90.940000,93.470000C90.631019,92.999711,90.249647,92.581214,89.810000,92.230000L92.290000,89.110000C93.070599,89.727161,93.746021,90.466748,94.290000,91.300000ZM85.440000,91.250000L84.540000,87.360000C85.523628,87.138191,86.536248,87.074059,87.540000,87.170000L87.160000,91.170000C86.586165,91.102008,86.005047,91.129037,85.440000,91.250000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(255,255,255)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba27"
        d="M147.650000,88.300000C146.829749,88.117942,146.045641,87.800243,145.330000,87.360000L145.920000,86.360000C146.537469,86.738380,147.213248,87.012071,147.920000,87.170000ZM152,88L151.610000,87C152.280655,86.770948,152.909049,86.433102,153.470000,86L154.180000,86.890000C153.520046,87.378541,152.783287,87.753679,152,88ZM142.410000,84.100000C142.048968,83.338659,141.809399,82.525473,141.700000,81.690000L142.830000,81.550000C142.925263,82.244956,143.131204,82.920172,143.440000,83.550000ZM156.690000,83.210000L155.620000,82.850000C155.843743,82.165520,155.958477,81.450119,155.960000,80.730000L157.100000,80.730000L157.100000,80.730000C157.100561,81.584202,156.958612,82.432512,156.680000,83.240000ZM143.430000,77.890000L142.430000,77.400000C142.795331,76.639915,143.281659,75.944195,143.870000,75.340000L144.690000,76.130000C144.168116,76.650240,143.738642,77.255560,143.420000,77.920000ZM154.900000,77.150000C154.509764,76.548029,154.023286,76.014254,153.460000,75.570000L154.170000,74.680000C154.828992,75.201946,155.399630,75.826610,155.860000,76.530000ZM147.900000,74.310000L147.640000,73.200000C148.463370,73.017273,149.310092,72.963298,150.150000,73.040000L150,74.210000C149.290936,74.139297,148.575113,74.183192,147.880000,74.340000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(149,189,81)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba28"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(149,189,81)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba29"
        d="M75.720000,55.940000L74.300000,55.940000L73.660000,56.860000L77.160000,67.190000L78.160000,67.730000C78.160000,67.730000,84.330000,67.370000,89.160000,70.410000C89.807534,70.760294,90.533848,70.939291,91.270000,70.930000C92.100000,70.780000,95.270000,69.670000,95.270000,69.670000C95.270000,69.670000,96.660000,67.560000,97.810000,66.170000C99.434009,64.579635,101.168325,63.105968,103,61.760000C104.831675,60.414032,100.660000,48.460000,100.110000,47.610000C99.560000,46.760000,98.910000,47.030000,98.910000,47.030000L88.340000,56.230000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(149,189,81)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba30"
        d="M99,50.150000C99.399182,51.293244,99.670830,52.477093,99.810000,53.680000L100.810000,60.150000C100.894678,60.477956,100.894678,60.822044,100.810000,61.150000C100.585177,61.576579,100.236579,61.925177,99.810000,62.150000C98.583698,63.028962,97.560602,64.161189,96.810000,65.470000C95.970000,66.930000,95.250000,68.790000,93.610000,69.180000C92.610000,69.430000,91.320000,68.980000,90.430000,69.600000C87.136478,67.532085,83.318723,66.452702,79.430000,66.490000L76.100000,57.420000C75.882861,56.932081,75.770442,56.404054,75.770000,55.870000C75.840000,54.750000,76.860000,53.750000,76.590000,52.660000C81.503100,54.542963,86.700356,55.577681,91.960000,55.720000C92.273341,55.798705,92.605468,55.731620,92.863695,55.537464C93.121922,55.343309,93.278598,55.042874,93.290000,54.720000C93.610000,53.400000,93.900000,52.080000,94.170000,50.720000C94.360000,49.780000,94.330000,46.980000,94.940000,46.310000C96.380000,44.750000,98.480000,48.800000,99,50.150000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(255,255,255)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba31"
        d="M99,50.150000C99.399182,51.293244,99.670830,52.477093,99.810000,53.680000L100.810000,60.150000C100.894678,60.477956,100.894678,60.822044,100.810000,61.150000C100.585177,61.576579,100.236579,61.925177,99.810000,62.150000C98.583698,63.028962,97.560602,64.161189,96.810000,65.470000C95.970000,66.930000,95.250000,68.790000,93.610000,69.180000C92.610000,69.430000,91.320000,68.980000,90.430000,69.600000C87.136478,67.532085,83.318723,66.452702,79.430000,66.490000L76.100000,57.420000C75.882861,56.932081,75.770442,56.404054,75.770000,55.870000C75.840000,54.750000,76.860000,53.750000,76.590000,52.660000C81.503100,54.542963,86.700356,55.577681,91.960000,55.720000C92.273341,55.798705,92.605468,55.731620,92.863695,55.537464C93.121922,55.343309,93.278598,55.042874,93.290000,54.720000C93.610000,53.400000,93.900000,52.080000,94.170000,50.720000C94.360000,49.780000,94.330000,46.980000,94.940000,46.310000C96.380000,44.750000,98.480000,48.800000,99,50.150000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="url(#ey4m1xtluoba31-fill)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba32"
        d="M76.420000,52.560000C78.273776,56.327394,79.757402,60.265870,80.850000,64.320000C80.868790,64.613115,81.035874,64.876371,81.293105,65.018152C81.550337,65.159933,81.862138,65.160630,82.120000,65.020000C85.711947,64.459106,89.373565,65.443529,92.200000,67.730000C93.633543,64.749260,95.638083,62.078805,98.100000,59.870000C98.288815,59.740417,98.421132,59.543730,98.470000,59.320000C98.480417,59.190368,98.459851,59.060117,98.410000,58.940000C96.926277,54.338820,96.065294,49.559694,95.850000,44.730000C92.430000,47.250000,88.730000,50.230000,88.140000,54.440000C84.420000,53.090000,80.410000,51.920000,76.420000,52.560000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(255,255,255)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba33"
        d="M92.160000,47.710000L94.160000,46L97.160000,59.430000C97.160000,59.430000,91.620000,64.700000,92.160000,67.730000L88.140000,54.440000C88.140000,54.440000,90.140000,49.420000,92.160000,47.710000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        opacity="0.30000001192092896"
        fill="rgb(149,189,81)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba34"
        d="M88.140000,54.440000L92.200000,67.730000C92.200000,67.730000,94.200000,59.090000,95.580000,56.230000L91,44.730000C91,44.730000,87.670000,50.470000,88.140000,54.440000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(255,255,255)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba35"
        d="M144.130000,58.900000C144.448698,58.652372,144.829122,58.496744,145.230000,58.450000C145.451050,58.460818,145.669658,58.501176,145.880000,58.570000L157.590000,62.060000C154.390000,66.360000,148.980000,68.400000,145.200000,72.200000C145.024005,72.398786,144.814073,72.564701,144.580000,72.690000C144.012913,72.827960,143.414133,72.730568,142.920000,72.420000C140.939861,71.521492,138.824565,70.957187,136.660000,70.750000C135.790000,70.660000,134.220000,71.020000,134.200000,70.110000C134.200000,69.400000,135.320000,68.110000,135.700000,67.470000C137.884739,64.059207,140.755651,61.140616,144.130000,58.900000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(255,255,255)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba36"
        d="M144.780000,92.370000C146.273215,95.547887,148.220218,98.491970,150.560000,101.110000C149.754893,101.797321,148.804385,102.293089,147.780000,102.560000C144.828751,103.646635,142.130346,105.324206,139.850000,107.490000C138.850000,105.630000,134.410000,99.490000,135.340000,97.600000C135.780000,96.720000,145,92.840000,144.780000,92.370000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(255,255,255)"
        stroke="none"
        strokeWidth={1}
      />
      <path
        id="ey4m1xtluoba37"
        d="M82.300000,110.420000C85.300000,110.600000,88.300000,110.890000,91.300000,111.310000C91.572866,111.322826,91.836456,111.413002,92.060000,111.570000C92.243584,111.759810,92.374551,111.994173,92.440000,112.250000C93.777092,116.177586,95.831928,119.822716,98.500000,123C95.500000,124.840000,86.830000,128.660000,83.940000,125C82.840000,123.560000,81.420000,110.370000,82.300000,110.420000Z"
        transform="matrix(1 0 0 1 -13.80000019073486 -6.32000017166138)"
        fill="rgb(255,255,255)"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  );
};

export default IdeaIcon;

IdeaIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
